export default __webpack_public_path__ + "static/media/Halloween-Bruja.91ec0c74.jpg";